<template>
    <div class="app-container">
        <el-row type="flex" align="middle">
            <span v-text-lbl="'StatisticalCycle'" class="demonstration">统计周期：</span>
            <el-date-picker v-model="datevalue" type="daterange" :range-separator="$tx('common.to', '至')" :start-placeholder="$tx('clgl.tjbb.startTime', '开始日期')" :end-placeholder="$tx('clgl.tjbb.endTime', '结束日期')" value-format="yyyy-MM-dd HH:mm:ss" @change="getDateArr" />
            <el-button v-pageBtn-lbl="'Statistics'" style="margin-left: 10px" type="primary" @click="getData">统计</el-button>
        </el-row>
        <div style="text-align: center; margin: 20px 0px 10px 0px">
            <span v-text-lbl="'UnitVehicle'" class="statistics_title" style="text-align: center">单位用车统计</span>
        </div>
        <div class="echart">
            <EchartColumnar :top="'15%'" :y-unit="yunit" :left="'50'" :x-unit="xunit" :right="'100'" :x-data="xData" :y-data="yData" :x-label-rotate="45" />
        </div>
        <div>
            <data-table ref="dataTable" :file-name="fileName" :list-tb="listTb" :list-data="listData" :show-summary="true" :get-summaries="getSummaries" />
        </div>
    </div>
</template>

<script>
import dataTable from './components/ListTable'
const moment = require('moment')
export default {
    components: {
        dataTable
    },
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'tjbb',
            xunit: { name: this.$tx('clgl.tjbb.dept', '部门'), align: 'end', size: '12' },
            yunit: { name: this.$tx('clgl.tjbb.num', '次数'), align: 'end', size: '12', lineColor: '#000' },
            listTb: [
                {
                    prop: 'flCreateDept',
                    // title: '用车部门',
                    title: this.$tx('clgl.tjbb.fields.flCreateDept', '用车部门'),
                    align: 'left'
                },
                {
                    prop: 'totalPerson',
                    title: this.$tx('clgl.tjbb.fields.totalPerson', '乘车人数'),
                    width: '100',
                    align: 'center'
                },
                {
                    prop: 'carUseNum',
                    title: this.$tx('clgl.tjbb.fields.carUseNum', '车辆使用次数'),
                    width: '135',
                    align: 'center'
                }
            ],
            listData: [],
            datevalue: ['', ''],
            xData: [],
            yData: [],
            fileName: '',
            xAxis: {
                splitLine: {
                    show: false
                }
            }
        }
    },
    computed: {},
    created() {
        this.$bus.emit('showNavSearch', false) // 搜索去掉
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按钮
        // setTimeout(() => {
        //     document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'block'
        // }, 300)
    },
    mounted() {
        // setTimeout(() => {
        //     document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'none'
        // }, 500)
        const now = moment().format('YYYY-MM-DD HH:mm:ss')
        const tow = moment().add(-30, 'days').format('YYYY-MM-DD HH:mm:ss')
        this.datevalue = [tow, now]
        const nownow = moment().format('YYYY年MM月DD日')
        const towtow = moment().add(-30, 'days').format('YYYY年MM月DD日')
        this.fileName = towtow + this.$tx('common.to', '至') + nownow + this.$tx('clgl.tjbb.UnitVehicle', '单位用车统计')
        this.getData()
    },
    methods: {
        // spanMethod(events) {
        //     if (events.rowIndex === this.listData.length - 1) {
        //         if (events.columnIndex === 0) {
        //             return [1, 2]
        //         } else if(events.columnIndex === 1){
        //             return [1, 0]
        //         }else{
        //              return [1, 1]
        //         }
        //     }
        // },
        getData() {
            this.$http({
                url: 'clgl/sendcar/learningStatistics',
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    startDate: this.datevalue[0],
                    endDate: this.datevalue[1]
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.listData = res.body.list
                    this.listData.length ? '' : (this.$refs['dataTable'].doing = false)
                    this.xData = []
                    this.yData = []
                    this.listData.forEach((args) => {
                        this.xData.push(args.flCreateDept)
                        this.yData.push(args.carUseNum)
                    })
                    this.yData = [this.yData]
                    this.xData = [this.xData]
                    console.log(123, this.yData, this.xData)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 更改时间
        getDateArr(data) {
            if (data) {
                this.datevalue = data
            } else {
                this.datevalue = ['', '']
            }
            this.fileName = moment(data[0]).format('YYYY年MM月DD日') + this.$tx('common.to') + moment(data[1]).format('YYYY年MM月DD日') + this.$tx('clgl.tjbb.UnitVehicle', '单位用车统计')
        },
        // 自定义合计
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = this.$tx('clgl.tjbb.hj', '合计')
                    return
                }
                const values = data.map((item) => Number(item[column.property]))
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                    }, 0)
                }
            })
            return sums
        }
    }
}
</script>

<style scoped lang="scss">
.echart {
    height: 300px;
    //   margin: 20px 0px 20px -8px!important
}
/deep/ .el-table__footer-wrapper .el-table__footer .has-gutter .el-table_1_column_1 {
    border-right: none;
}
</style>
<style>
.el-date-editor .el-range-separator {
    width: 6%;
}
</style>
